<template>
  <div class="big">
    <DocMsg
      :isFlag="doc_msg"
      :doctorId="doctorId"
    ></DocMsg>
    <div class="container">
      <div class="searchbox">
        <div class="item">
          <span class="itemtitle">医生姓名</span>
          <el-input
            v-model="doctor_name"
            size="medium"
            style="width:120px"
            @change="search"
          ></el-input>
        </div>
        <div class="item">
          <span class="itemtitle">医生手机</span>
          <el-input
            v-model="phone"
            size="medium"
            style="width:120px"
            @change="search"
          ></el-input>
        </div>
        <div class="item">
          <span class="itemtitle">医院名称</span>
          <el-input
            v-model="hospital"
            size="medium"
            style="width:120px"
            @change="search"
          ></el-input>
        </div>
        <div class="item">
          <span class="itemtitle">模板名称</span>
          <el-input
            v-model="tmp_name"
            size="medium"
            style="width:120px"
            @change="search"
          ></el-input>
        </div>
        <div class="item">
          <el-button
            type="primary"
            @click="search"
            size="medium"
          >查询</el-button>
          <el-button
            plain
            @click="reSet"
            size="medium"
          >重置</el-button>
        </div>
      </div>
      <div style="margin:16px 0;text-align:left">
        <span style="margin-right:10px">是否测试医生</span>
        <span>
          <el-radio-group
            v-model="is_test"
            @change="search"
          >
            <el-radio :label="0">全部</el-radio>
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </span>
        <span style="margin:0 10px 0 20px">是否特殊模板</span>
        <span>
          <el-radio-group
            v-model="is_special_tmp"
            @change="search"
          >
            <el-radio :label="''">全部</el-radio>
            <el-radio :label="1">特殊模板</el-radio>
            <el-radio :label="0">省市模板</el-radio>
          </el-radio-group>
        </span>
      </div>
      <div style="border: solid 1px #c9cbd6;">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%;min-width:1000px;"
          :header-cell-style="{background:'#F5F5F5'}"
        >
          <el-table-column label="医生姓名">
            <template slot-scope="scope">
              <span
                @click="showDocMsg(scope.row.doctor_id)"
                style="cursor:pointer"
              >{{scope.row.doctor_name}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="phone"
            label="手机号"
          ></el-table-column>
          <el-table-column
            prop="hospital"
            label="医院"
          ></el-table-column>
          <el-table-column
            prop="tmp_name"
            label="模板名称"
          ></el-table-column>
          <el-table-column
            prop="tmp_remark"
            label="模板备注"
          ></el-table-column>
          <el-table-column
            prop="tmp_remark"
            label="类型"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.special_tmp_id==1">特殊模板</span>
              <span v-if="scope.row.special_tmp_id==0">省市模板</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          style="margin:20px 0"
        ></el-pagination>
      </div>
    </div>
    <!-- 设置医生弹窗 -->
    <el-dialog
      title="添加医生"
      :visible.sync="adddoctor"
      width="800px"
      :close-on-click-modal="false"
      :before-close="closeDia"
    >
      <div style="padding: 10px 20px">
        <div
          class="searchbox"
          style="margin-bottom:20px"
        >
          <div class="item">
            <span class="itemtitle">医生姓名</span>
            <el-input
              v-model="doctor_name_d"
              size="medium"
              style="width:160px"
              @change="searchDoctor"
            ></el-input>
          </div>
          <div class="item">
            <span class="itemtitle">医生手机</span>
            <el-input
              v-model="phone_d"
              size="medium"
              style="width:160px"
              @change="searchDoctor"
            ></el-input>
          </div>
          <div class="item">
            <span class="itemtitle">医院名称</span>
            <el-input
              v-model="hospital_d"
              size="medium"
              style="width:160px"
              @change="searchDoctor"
            ></el-input>
          </div>
          <div class="item">
            <span class="itemtitle">所在省市</span>
            <el-select
              v-model="province_id"
              placeholder="请选择"
              @change="searchDoctor"
              style="width: 160px;"
              clearable
            >
              <el-option
                v-for="item in proList"
                :key="item.province_id"
                :label="item.name"
                :value="item.province_id"
              ></el-option>
            </el-select>
          </div>
          <div class="item">
            <el-button
              type="primary"
              @click="searchDoctor"
              size="medium"
            >查询</el-button>
          </div>
        </div>
        <div style="padding:0 10px">
          <div style="border: solid 1px #c9cbd6;">
            <el-table
              ref="multipleTable"
              :data="doctorData"
              tooltip-effect="dark"
              style="width: 100%;"
              :header-cell-style="{background:'#F5F5F5'}"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection"></el-table-column>
              <el-table-column
                prop="doctor_name"
                label="医生姓名"
              ></el-table-column>
              <el-table-column
                prop="phone"
                label="手机号"
              ></el-table-column>
              <el-table-column
                prop="hospital"
                label="医院"
              ></el-table-column>
              <el-table-column
                prop="tmp_name"
                label="已绑定模板"
              ></el-table-column>
            </el-table>
          </div>
        </div>
        <div>
          <el-pagination
            @size-change="doctorSizeChange"
            @current-change="doctorCurrentChange"
            :current-page="currentPage_d"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagesize_d"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalDoc"
            style="margin:10px 0 20px 0"
          ></el-pagination>
        </div>
      </div>
      <div style="padding-bottom:20px">
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            type="primary"
            @click="setDoctor"
            size="medium"
          >添加，并继续查询</el-button>
          <el-button
            plain
            @click="closeDia"
            size="medium"
          >取消</el-button>
        </span>
      </div>
    </el-dialog>
    <!-- 选择模板弹窗 -->
    <el-dialog
      title="请选择自定义模板"
      :visible.sync="checktem"
      width="500px"
      :close-on-click-modal="false"
    >
      <div style="padding:20px">
        <div style="border: solid 1px #c9cbd6;margin-bottom:20px">
          <el-table
            ref="multipleTable"
            :data="temList"
            tooltip-effect="dark"
            style="width: 100%;"
            :header-cell-style="{background:'#F5F5F5'}"
          >
            <el-table-column width="70">
              <template slot-scope="scope">
                <el-checkbox
                  v-model="scope.row.check"
                  @change="(value)=>{return changeCheck(value,scope.row)}"
                ></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
              prop="tmp_name"
              label="模板名称"
            ></el-table-column>
            <el-table-column
              prop="tmp_remark"
              label="模板备注"
            ></el-table-column>
          </el-table>
        </div>
        <div v-if="check_id">
          <el-button
            type="primary"
            size="medium"
            @click="editDoctorTem"
          >确定</el-button>
          <el-button
            plain
            size="medium"
            @click="checktem=false"
          >取消</el-button>
        </div>
        <div v-else>
          <el-button
            type="primary"
            size="medium"
            @click="nextStep"
          >下一步</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import DocMsg from '../../../components/common/DocMsg.vue';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      currentPage_d: 1,
      pagesize_d: 10,
      doctorData: [],
      adddoctor: false,
      doctor_name: '',
      phone: '',
      hospital: '',
      tmp_name: '',
      is_test: 0,
      is_special_tmp: '',
      doctor_name_d: '',
      province_id: '',
      phone_d: '',
      hospital_d: '',
      proList: [],
      checktem: false,
      temList: [],
      totalDoc: 0,
      tmp_id: '', //选择的模板id
      check_id: '',
      doc_msg: false,
      doctorId: ''
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  components: {
    DocMsg
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取医生列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        doctor_name: this.doctor_name,
        phone: this.phone,
        hospital: this.hospital,
        tmp_name: this.tmp_name,
        is_test: this.is_test,
        is_special_tmp: this.is_special_tmp
      };
      this.axios
        .post('platform/Drugtype/drugTypeTemplateDoctor', data)
        .then((res) => {
          if (res.code == 0) {
            if (!res.data.list.length && this.currentPage > 1) {
              this.currentPage = this.currentPage - 1;
              this.getList();
            }
            this.tableData = res.data.list;
            this.totalNum = res.data.total;
          }
        });
    },
    //获取省市列表
    getProvince() {
      this.axios
        .post('platform/platform/getProvinceCityDistrict')
        .then((res) => {
          this.proList = res.data.list;
        });
    },
    //重置搜索
    reSet() {
      this.doctor_name = '';
      this.phone = '';
      this.hospital = '';
      this.tmp_name = '';
      this.is_test = 0;
      this.getList();
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //模板列表
    getTemList() {
      this.axios
        .post('platform/Drugtype/getDrugTypeTemplateLists')
        .then((res) => {
          if (res.code == 0) {
            this.temList = res.data.list.map((item) => {
              item.check = false;
              return item;
            });
          }
        });
    },
    //选择模板弹窗
    adddialog() {
      this.currentPage = 1;
      this.pagesize = 10;
      this.totalNum = 0;
      this.checktem = true;
    },
    //选择模板
    changeCheck(value, row) {
      if (value) {
        this.temList.forEach((item) => {
          item.check = false;
        });
        row.check = true;
        this.tmp_id = row.tmp_id;
      } else {
        this.tmp_id = '';
      }
    },
    //添加医生按钮 弹窗
    addDoctorDia() {
      this.temList.forEach((item) => {
        item.check = false;
      });
      this.tmp_id = '';
      this.checktem = true;
    },
    //下一步选择医生弹窗
    nextStep() {
      if (!this.tmp_id) {
        this.$message.error('请先选择剂型模板');
        return false;
      }
      this.checktem = false;
      this.currentPage_d = 1;
      this.pagesize_d = 10;
      this.doctor_name_d = '';
      this.hospital_d = '';
      this.phone_d = '';
      this.getDoctorList();
      this.adddoctor = true;
    },
    //医生多选
    handleSelectionChange(val) {
      let selection = val.map((item) => {
        return item.doctor_id;
      });
      this.check_id = selection.toString();
    },
    //查询医生
    getDoctorList() {
      let data = {
        page: this.currentPage_d,
        pageNumber: this.pagesize_d,
        doctor_name: this.doctor_name_d,
        hospital: this.hospital_d,
        phone: this.phone_d,
        province_id: this.province_id
      };
      this.axios
        .post('platform/Drugtype/getTemplateDoctor', data)
        .then((res) => {
          if (res.code == 0) {
            this.doctorData = res.data.list;
            this.totalDoc = res.data.total;
          }
        });
    },
    //选择医生每页数据的条数
    doctorSizeChange(size) {
      this.pagesize_d = size;
      this.getDoctorList();
    },
    //选择医生当前第几页
    doctorCurrentChange(currentPage) {
      this.currentPage_d = currentPage;
      this.getDoctorList();
    },
    //添加医生搜索
    searchDoctor() {
      this.currentPage_d = 1;
      this.getDoctorList();
    },
    //设置医生
    setDoctor() {
      if (!this.check_id) {
        this.$message.error('请先选择添加的医生');
        return false;
      }
      let data = {
        tmp_id: this.tmp_id,
        doctor_id: this.check_id
      };
      this.axios
        .post('platform/Drugtype/updatedrugTypeTemplateDoctor', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('添加成功');
            this.check_id = '';
            this.getDoctorList();
          }
        });
    },
    //关闭弹窗
    closeDia() {
      this.currentPage_d = 1;
      this.pagesize_d = 10;
      this.currentPage = 1;
      this.pagesize = 10;
      this.adddoctor = false;
      this.getList();
    },
    //修改模板按钮
    editTem(doctor_id) {
      this.check_id = doctor_id;
      this.checktem = true;
    },
    //修改模板按钮
    editDoctorTem() {
      let data = {
        tmp_id: this.tmp_id,
        doctor_id: this.check_id
      };
      this.axios
        .post('platform/Drugtype/updatedrugTypeTemplateDoctor', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('修改成功');
            this.check_id = '';
            this.checktem = false;
            this.getList();
          }
        });
    },
    //删除医生
    delDoctor(doctor_id) {
      this.axios
        .post('platform/Drugtype/deldrugTypeTemplateDoctor', { doctor_id })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('已删除绑定，该医生将使用默认模板');
            this.getList();
          }
        });
    },
    back() {
      history.back();
    }
  },
  created() {
    this.getList();
    this.getProvince();
    this.getTemList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 231px);
  text-align: center;
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
  .item {
    margin-right: 15px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    .itemtitle {
      display: inline-block;
      margin-right: 5px;
    }
  }
}
</style>